import Debug from 'debug';
import _ from 'lodash';
const debug = Debug(`knack.core.helpers.entry.getProfileKey`);
export const getProfileKey = (entry, object_key) => {
    if (!entry || !entry.profile_objects) {
        return ``;
    }
    const profile = _.find(entry.profile_objects, function (profile_candidate) {
        return profile_candidate.object == object_key;
    });
    return profile ? profile.entry_id : ``;
};
